import React, { Component } from 'react'
import { FaBookmark, FaRegBookmark } from "react-icons/fa6";

export default class Bookmark extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isBookmarked: this.props.value,
        }
    }

    render() {
        return (
            <button
                type='button'
                className='bookmark-question'
                aria-label={this.state.isBookmarked ? 'Remove bookmark from this question' : 'Bookmark this question'}
                aria-pressed={this.state.isBookmarked}
                onClick={() => {
                this.setState({
                    isBookmarked: !this.state.isBookmarked,
                })
                this.props.handleBookmarkClick()
            }}>
                {this.state.isBookmarked ?
                    <FaBookmark aria-hidden='true' fontSize={22} fontWeight={100} color='#ebc351' />
                    : <FaRegBookmark aria-hidden='true' fontSize={22} fontWeight={100} color='#666' />
                }

            </button>
        )
    }
}
